import handleFetch from './handleFetch';
import { getUrlWithAccessCode } from '../stores/referrer';
import handleSAASError from './handleSAASError';

interface FetchOptions {
  ndc: string;
  quantity: string;
  zip?: string;
  limit?: number;
  index?: number;
  npi?: string;
  referrer?: string;
  signal?: Request['signal'];
  additionalHeaders?: AdditionalHeaders;
}

interface AdditionalHeaders {
  [key: string]: string;
}

interface FetchBody {
  ndc: string;
  quantity: number;
  npis?: string[];
  zip?: string;
}

export default (options: FetchOptions, errorKey?: string): Promise<Response | Error> => {
  const { ndc, quantity, zip, npi, limit, index, signal, additionalHeaders = {} } = options;
  const body: FetchBody = {
    ndc,
    quantity: Number.parseFloat(quantity),
  };
  let url;

  if (npi) {
    body.npis = [npi];
    url = `${process.env.SAAS_PRICING_BY_NPI_ENDPOINT}`;
  } else {
    body.zip = zip;
    url = `${process.env.SAAS_PRICING_BY_REGION_ENDPOINT}?limit=${limit || 10}&index=${index || 0}`;
  }

  return handleFetch(getUrlWithAccessCode(url), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.SAAS_API_KEY || '',
      ...additionalHeaders,
    },
    body: JSON.stringify(body),
    signal,
  })
    .then((ret) => ret.json())
    .then((ret) => {
      if (ret.statusCode >= 400) {
        const { id, message } = ret;
        handleSAASError(errorKey || 'Error fetching prices.', id, { errorMessage: message });
        throw ret;
      }
      return ret;
    });
};
